<button [ngClass]="buttonClasses" [disabled]="disabled">
  <ion-icon [name]="icon"></ion-icon>
</button>